import React from 'react';
import SearchSelect from '../generics/SearchSelect'

const InputBox = (props) => {
  var inputStyle = {'zIndex': 0};
  const weightShouldBeLimited = props.weightShouldBeLimited()
  return (
    <div>
      <h5>{props.title ? props.title : 'Create/Edit Invoice Items'}</h5>
      <div className="row">
        <div className="col-sm-12">
          <div className="card" key={props.index}>
            <div className="card-block">
              <form className="row">

                <SearchSelect onChange={props.onItemChange}
                              getOptions={props.searchItems}
                              isLoading={props.isLoadingItems}
                              value={props.selectedItem}
                              error={(props.errors.indexOf('item') !== -1)}
                              class="col-sm-6 form-group row"
                              classLabel="col-sm-4 col-form-label"
                              classInput="col-sm-8"
                              label="Item"
                />

                <div className={`col-sm-6 form-group row ${(props.errors.indexOf('station') !== -1) ? " has-danger" : ""}`}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">Destination</label>
                  <div className="col-sm-8">
                    <select id="select" name="select" className={(props.errors.indexOf('station') !== -1) ? "form-control form-control-danger" : "form-control"} size="1" value={props.station} onChange={(station) => props.onStationChange(station)}>
                      <option value={-1}>Select station</option>
                        {props.stations? (props.stations.map((station,index) => {
                              return(<option value={index} label={station.name} key={station.id}>{station.name}</option>)
                            })) : <option value=" ">Loading...</option>
                        }
                    </select>
                  </div>
                  {(props.errors.indexOf('station') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select Station</em> : <em></em>}
                </div>

                <div className={(props.errors.indexOf('brand') !== -1) ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">Manufacturer</label>
                  <div className="col-sm-8">
                    <select id="select" name="select" className={(props.errors.indexOf('brand') !== -1) ? "form-control form-control-danger" : "form-control"} size="1" value={props.brand} onChange={(brand) => props.onBrandChange(brand)}>
                      <option value={-1}>Select brand</option>
                        {props.brands ? (props.brands.map((brand,index) => {
                              return(<option value={index} key={brand.id}>{brand.brand_name}</option>)
                            })) : <option value=" ">Loading...</option>
                        }
                    </select>
                  </div>
                  {(props.errors.indexOf('brand') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select Brand</em> : <em></em>}
                </div>

                <div className={`col-sm-6 form-group row ${(props.errors.indexOf('price') !== -1 || props.price < 0) && "has-danger"}`}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">Price</label>
                  <div className="col-sm-8 input-group">
                    <div className="input-group-addon">$</div>
                    <input style={inputStyle} type="number" id="text-input" min={1} name="text-input" className="form-control" placeholder="Price" value={props.price}  onChange={(price) => props.onPriceChange(price,props.index)}/>
                  </div>
                  {(props.errors.indexOf('price') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter a positive integer value.</em> : <em></em>}
                </div>

                <div className={`col-sm-6 form-group row ${((weightShouldBeLimited && props.weight > 99) || props.weight < 0) && "has-danger"}`}>
                  <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">Qty</label>
                  <div className="col-sm-6 col-10">
                    <input type="number"
                           id="text-input"
                           name="text-input"
                           min={1}
                           max={weightShouldBeLimited ? 99 : null}
                           className="form-control"
                           placeholder="Enter quantity"
                           value={props.weight}
                           onChange={(item) => props.onWeightChange(item, props.index)}/>
                  </div>
                  <div className="col-sm-2 col-2 pl-0">
                    <h4><span className="badge badge-pill badge-info">{props.measureUnit ? props.measureUnit : 'kg'}</span></h4>
                  </div>
                  {(props.errors.indexOf('weight') !== -1) ?
                    <em id="firstname-error" className="error form-control-feedback">{weightShouldBeLimited ? 'Please enter a qty between 1 and 100' : 'Please enter a qty greater than 0'}</em>
                    : <em></em>}
                </div>

                <div className={`col-sm-6 form-group row ${(props.errors.indexOf('numberItems') !== -1 || props.numberItems < 0) && "has-danger"}`}>
                  <label className="col-sm-4 col-form-label" htmlFor="select">Pieces</label>
                  <div className="col-sm-8">
                    <input type="number" min={1} id="text-input" name="text-input" className={(props.errors.indexOf('numberItems') !== -1) ? "form-control form-control-danger" : "form-control"} placeholder="Enter number of items" value={props.numberItems} onChange={(item) => props.onNumberItemsChange(item,props.index)}/>
                  </div>
                  {(props.errors.indexOf('numberItems') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter a positive integer value.</em> : <em></em>}
                </div>

                <div className={(props.errors.indexOf('packingDate') !== -1) ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="select">Packing Date</label>
                  <div className="col-sm-8">
                    <input type="date" id="date" className={(props.errors.indexOf('packingDate') !== -1) ? "form-control form-control-danger" : "form-control"} value={props.packingDate}  onChange={(date) => props.onDatePackingChange(date,props.index)}/>
                  </div>
                  {(props.errors.indexOf('packingDate') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select a valid packing date</em> : <em></em>}
                </div>

                {props.hasGrade &&
                  (<div className={(props.errors.indexOf('grade') !== -1) ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                    <label className="col-sm-4 col-form-label" htmlFor="text-input">Grade</label>
                    <div className="col-sm-8">
                      <select id="select" name="select"
                              className={(props.errors.indexOf('grade') !== -1) ? "form-control form-control-danger" : "form-control"}
                              size="1" value={props.grade} onChange={(grade) => props.onGradeChange(grade)}>
                        <option value={-1}>Select grade</option>
                          {props.grades ? (props.grades.map((grade,index) => {
                                return(<option value={index} key={grade.id}>{grade.grade}</option>)
                              })) : <option value=" ">Loading...</option>
                          }
                      </select>
                    </div>
                    {(props.errors.indexOf('grade') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select Grade</em> : <em></em>}
                  </div>)
                }
                {/* when the station id equals 1 (butcher), plant input should become available */}
                {props.station === 1 &&
                  (<div className={(props.errors.indexOf('plant') !== -1) ? "col-sm-6 form-group row has-danger" :"col-sm-6 form-group row"}>
                    <label className="col-sm-4 col-form-label" htmlFor="select">Plant</label>
                    <div className="col-sm-8">
                      <input type="text" id="text-input" name="text-input" className={(props.errors.indexOf('plant') !== -1) ? "form-control form-control-danger" : "form-control"} placeholder="Enter plant" value={props.plant} onChange={(item) => props.onPlantChange(item,props.plant)}/>
                    </div>
                    {(props.errors.indexOf('plant') !== -1)? <em id="firstname-error" className="error form-control-feedback">Plant must be filled if the station is butcher</em> : <em></em>}
                  </div>)
                }
                <div className={(props.errors.indexOf('vendor_lot_number') !== -1) ? "col-sm-6 form-group row has-danger" :"col-sm-6 form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="lot-input">Lot</label>
                  <div className="col-sm-8">
                    <input type="text" id="lot-input" name="lot-input" className={(props.errors.indexOf('vendor_lot_number') !== -1) ? "form-control form-control-danger" : "form-control"} placeholder="Enter lot" value={props.vendor_lot_number} onChange={props.onLotChange}/>
                  </div>
                  {(props.errors.indexOf('vendor_lot_number') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please enter a lot number</em> : <em></em>}
                </div>
              </form>
              {props.index === -1?
              <div className="add-repeat-btn">
                  <span className="pl-1 pr-05">Repeat</span>
                  <input type="number" className={`form-control w-10 ${(props.errors.indexOf('repeat') !== -1) ? "form-control-danger" : ""}`}
                  value={props.numberBoxes}
                  onChange={(numberBoxes) => props.onNumberBoxesChange(numberBoxes)}/>
                <span className="pl-05 pr-1">times</span>
                  <span className="btn btn-danger m-0" onClick={()=>props.submitBox()}>Add</span>
              </div>
              :
              <div className="row">
                <div className="col-sm-6">
                  <span className="btn btn-danger" onClick={()=>props.submitBox(false)}>Save</span>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InputBox;
